import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

export const useStableSearchParams = () => {
  const searchParams = useSearchParams();

  return useMemo(() => {
    if (!searchParams) return null;
    const stable = new URLSearchParams(searchParams.toString());
    stable.delete('tab');
    return stable.toString();
  }, [searchParams]) as ReadonlyURLSearchParams | null;
};
